import { createReducer } from 'typesafe-actions'
import { combineReducers } from 'redux'
import { payloadReducer } from '../../../utils/redux-utils'
import { getId } from '../../../utils/entity-utils'
import type { NormalizedDepartment } from '../../../responses/refs/refs'
import type { ID } from '../../../types/UtilityTypes'
import { normalizeDepartments } from '../../../utils/normalize'
import { taskListActions } from './task-list-actions'
import { taskActions } from '../../data/task/task-actions'
import { RequestStatus } from '../../../responses/response'
import { TaskStatus } from '../../../constants/enums'
import { conditionSnoc } from '../../../utils/utils'

export interface TasksPageState {
    departments: NormalizedDepartment[],
    tasks: ID[],
    status: RequestStatus,
}

export const tasksReducer = combineReducers<TasksPageState>({
    departments: createReducer<NormalizedDepartment[]>([])
        .handleAction(taskListActions.departments.success, (_, action) => action.payload.map(normalizeDepartments)),
    tasks: createReducer<ID[]>([])
        .handleAction(taskActions.requested.success, (_, action) => action.payload.map(getId))
        .handleAction(taskActions.remove.success, (state, action) => state.filter(id => id !== action.payload))
        .handleAction(taskActions.create.success, (state, action) =>
            conditionSnoc(action.payload.status_id === TaskStatus.REQUESTED, action.payload.id)(state)
        )
        .handleAction(taskListActions.setTasks, payloadReducer),
    status: createReducer<RequestStatus>(RequestStatus.INITIAL)
        .handleAction(taskListActions.departments.request, () => RequestStatus.FETCHING)
        .handleAction(taskListActions.departments.success, () => RequestStatus.SUCCESS)
        .handleAction(taskListActions.departments.failure, () => RequestStatus.FAILURE),
})

